import { REACTION_GROUP_BY } from '@/constants/reactionStats';
import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const StatsRow = ({ group, groupBy }) => {
	const getGroupName = () => {
		if (group.categoryName) return group.categoryName;
		if (group.instructorName) return group.instructorName;
		if (groupBy.toLowerCase() === REACTION_GROUP_BY.CATEGORY) return 'Class Videos';
		return 'Other Videos';
	};
	const [groupName, setGroupName] = useState('');
	const [isExpanded, setIsExpanded] = useState(false);
	const items = group.items.flat();
	const cellStyle = { padding: '0.5rem', border: '0.06rem solid #ccc' };
	const itemCellStyle = { padding: '0.25rem 0.5rem', border: '0.06rem solid #ccc', fontWeight: 'normal' };

	useEffect(() => {
		setGroupName(getGroupName());
	}, [group]);

	return (
		<>
			<tr
				onClick={() => setIsExpanded(!isExpanded)}
				style={{ cursor: 'pointer', fontWeight: 'bold', borderTop: '0.13rem solid #000' }}
			>
				<td style={cellStyle}>{groupName}</td>
				<td style={cellStyle}>{group.totalLikes}</td>
				<td style={cellStyle}>{group.totalDislikes}</td>
				<td style={{ ...cellStyle, textAlign: 'center' }}>
					<FaChevronDown
						style={{
							transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
							transition: 'transform 0.2s'
						}}
					/>
				</td>
			</tr>

			{isExpanded && items.length > 0 && (
				<>
					<tr style={{ backgroundColor: '#e9e9e9' }}>
						<td style={itemCellStyle}>Title</td>
						<td style={itemCellStyle}>Likes</td>
						<td style={itemCellStyle}>Dislikes</td>
						<td style={itemCellStyle}></td>
					</tr>

					{items.map((item, index) => (
						<tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
							<td style={{ ...itemCellStyle, paddingLeft: '1.25rem' }}>{item.title}</td>
							<td style={itemCellStyle}>{item.likes}</td>
							<td style={itemCellStyle}>{item.dislikes}</td>
							<td style={itemCellStyle}></td>
						</tr>
					))}
				</>
			)}
			{isExpanded && items.length === 0 && (
				<tr>
					<td
						colSpan="4"
						style={{ textAlign: 'center', padding: '0.5rem', border: '0.06rem solid #ccc', fontStyle: 'italic' }}
					>
						No individual video data available for this {groupBy.toLowerCase()}.
					</td>
				</tr>
			)}
		</>
	);
};

export default StatsRow;
